import { useState } from 'react';
import { Col, ConfigProvider, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { useDevice } from '@/hooks';
import { useAttendanceReport } from '@/hooks/app';
import { getEndOfCurrentMonth, getStartOfCurrentMonth } from '@/utils';
import { CalendarDate, Flex, InputCalendar, PageContainer } from '@/components/common';
import AttendanceReportDesktop from './AttendanceReportDesktop';
import AttendanceReportMobile from './AttendanceReportMobile';

export default function DormitoryAttendanceReport() {

  const [t] = useTranslation(['common', 'dormitory']);
  const start = getStartOfCurrentMonth();
  const end = getEndOfCurrentMonth();

  const [startDate, setStartDate] = useState(start.str);
  const [endDate, setEndDate] = useState(end.str);
  const { isDesktop } = useDevice();
  const report = useAttendanceReport();

  return (
    <PageContainer hideScrollbar={!isDesktop()} displayFlex title={t('dormitory:labels.attendance-report')}>
      <ConfigProvider componentSize={isDesktop() ? 'large' : 'middle'}>
        <Flex className="w-full h-full" direction="column">
          <Row className="w-full mt-2" gutter={[16, 16]}>
            <Col xxl={4} xl={6} lg={8} span={12}>
              <InputCalendar
                value={startDate}
                defaultDate={start.date as any}
                className="text-center"
                placeholder={t('common:labels.start-date')}
                onChange={(d: CalendarDate) => setStartDate(d.strEn)}
              />
            </Col>
            <Col xxl={4} xl={6} lg={8} span={12}>
              <InputCalendar
                value={endDate}
                defaultDate={end.date as any}
                className="text-center"
                placeholder={t('common:labels.end-date')}
                onChange={(d: CalendarDate) => setEndDate(d.strEn)}
              />
            </Col>
          </Row>
          <Row className="h-full">
            <Col className="h-full" span={24}>
              {isDesktop() ?
                <AttendanceReportDesktop
                  startDate={startDate}
                  endDate={endDate}
                  {...report} /> :
                <AttendanceReportMobile
                  startDate={startDate}
                  endDate={endDate}
                  {...report} />
              }
            </Col>
          </Row>
        </Flex>
      </ConfigProvider>
    </PageContainer>
  );
}
